import { useQuery } from '@tanstack/react-query'

import API from '../../../utils/api'

export const useCatalogRecent = () => {
  const { data, isLoading, refetch, error } = useQuery(
    ['/GamesCatalog/recent'],
    API.getRecentGames,
    {
      staleTime: Infinity,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
    }
  )

  return {
    games: data?.data?.games || [],
    refetch,
    error,
    isLoading,
  }
}
